import { createStore } from 'owa-satcheljs';
import type {
    CopilotChatDrawerStore,
    CopilotChatDrawerState,
} from './schema/copilotChatDrawerStoreSchema';
import { DEFAULT_COPILOT_CHAT_DRAWER_WIDTH } from '../utils/copilotChatDrawerConstants';
import { isFeatureEnabled } from 'owa-feature-flags';

const copilotChatDrawerStore: CopilotChatDrawerStore = {
    chatDrawerStateMap: new Map<Window, CopilotChatDrawerState>(),
};

export const getStore: () => CopilotChatDrawerStore = createStore<CopilotChatDrawerStore>(
    'CopilotChatDrawerStore',
    copilotChatDrawerStore
);

/**
 * Returns the state for the given window, or undefined if not initialized.
 * Note: Selectors should call this function, as this does NOT create state as
 *       selectors should not mutate state.
 */
export const getCopilotChatDrawerState = (
    targetWindow: Window
): CopilotChatDrawerState | undefined => {
    return getStore().chatDrawerStateMap.get(targetWindow);
};

/**
 * Cleanup function to remove window instance key from store,
 * called when a window unmounts.
 */
export const removeCopilotChatDrawerState = (targetWindow: Window): void => {
    getStore().chatDrawerStateMap.delete(targetWindow);
};

/**
 * Default initial state for a new window instance.
 * Use this as a baseline template for mutators that create state.
 */
export const getInitialState = (): CopilotChatDrawerState => {
    return {
        isShown: false,
        userPreferredWidth: isFeatureEnabled('mon-copilot-bizchat-drawer-leftnav-collapse')
            ? DEFAULT_COPILOT_CHAT_DRAWER_WIDTH
            : 0,
        appCanvasWidth: 0,
        showInReadingPane: false,
    };
};
